module.exports = __webpack_public_path__ + "img/Villa_Borna_17.ccecfa47.jpg";